<template>
  <loading-wrapper :loading="loading">
    <row appearance="spaced">
      <cell :cols="filters.length > 1 ? 'auto' : '12 6-md 4-lg '">
        <filter-ui
          :disabled="controlsDisabled"
          :value="prepared"
          :available="availableMap"
          :filters="filters"
          @input="handleInput"
          @filtrate="filtrate"
        />
      </cell>
      <cell cols="12 narrow-md">
        <row>
          <cell cols="narrow">
            <control-button
              @click.prevent="filter"
              :disabled="controlsDisabled"
              styling="primary"
              size="md"
            >
              <icon name="search" size="lg" />
            </control-button>
          </cell>
          <cell cols="narrow" v-if="!empty">
            <control-button
              @click.prevent="clear"
              :disabled="controlsDisabled"
              styling="danger"
              size="md"
            >
              <icon name="close" size="lg" />
            </control-button>
          </cell>
        </row>
      </cell>
    </row>
  </loading-wrapper>
</template>

<script>

import { isEmpty } from '@aspectus/vue-utils';
import isShallowEqual from '@wordpress/is-shallow-equal';
import FilterUi from './Ui';

function orderFilters(list, order) {
  const map = list.reduce((acc, x) => {
    acc[x.id] = x;
    return acc;
  }, {});

  return order.filter(x => !!map[x]).map(x => map[x]);
}

export default {
  inheritAttrs: false,
  props: [
    'loading',
    'detailsLoading',
    'detailsLoaded',
    'availableLoaded',
    'schema',
    'receiveSchema',
    'hasSchemaResource',
    'availableLoading', // загрузка доступных значений отдельно от загрузки структуры
    'value',
    'receive',
    'all',
    'available',
    'receiveAvailable',
    'displayed',
    'autoupdatable',
    'permanent',
  ],

  components: {
    FilterUi,
  },

  data() {
    return {
      prepared: {},
    };
  },

  watch: {
    value: {
      immediate: true,
      handler({ filters = {} } = {}, { filters: oldFilters } = {}) {
        if (isShallowEqual(filters, oldFilters)) {
          return;
        }

        this.prepare(filters);
        this.receiveAvailable({ filters });
      },
    },
  },

  created() {
    if (
      this.hasSchemaResource
      && this.receiveSchema
    ) {
      this.receiveSchema();
    }
    this.receive(this.value);
    // this.receiveAvailable(this.value);
  },

  computed: {
    empty() {
      return Object.values(this.prepared).every(isEmpty);
    },
    filters() {
      const source = (
        this.all
        && this.all.length
      )
        ? this.all
        : this.schema;

      return (
        source
        && source.length
        && this.displayed
      )
        ? orderFilters(source, this.displayed)
        : [];
    },
    controlsDisabled() {
      // Старые каталоги сохраняют прежнее поведение.
      if (!this.hasSchemaResource) {
        return (
          this.loading
          || this.availableLoading
        );
      }

      // Progressive mode:
      // схема уже может быть видна,
      // но взаимодействие разрешаем только после
      // full definitions + available.
      return (
        this.loading
        || this.detailsLoading
        || !this.detailsLoaded
        || this.availableLoading
        || !this.availableLoaded
      );
    },
    availableMap() {
      if (!this.available) {
        return {};
      }

      return this.available.reduce((acc, x) => {
        acc[x.id] = x;
        return acc;
      }, {});
    },
  },

  methods: {
    prepare(value) {
      this.prepared = value;
    },
    handleInputFilter(value) {
      this.handleInput(value);
      this.filter();
    },
    handleInput(value, key) {
      this.prepare(value);

      if (this.autoupdatable && this.autoupdatable.includes(key)) {
        this.receiveAvailable({ filters: this.prepared });
      }
    },
    filtrate(value, key) {
      this.prepared = value;
      this.filter();
    },
    filter() {
      this.$emit('input', { ...this.value, filters: this.prepared });
    },
    clear() {
      this.$emit('input', { ...this.value, filters: { }, ...this.permanent });
      this.prepare({ filters: {}, ...this.permanent });
    },
  },
};

</script>
